/** @file Throws a Pose2DError as an Error carrying the structured value (read it back with toPose2DError). */
import type { ErrorCode } from './errorCodes';
import { makeError, type Pose2DError } from './pose2dError';

/** Never returns: `throw`s `Error("<message> at <path>: <hint>")` with the structured error attached as `.pose2d`. */
export function throwError(code: ErrorCode, params?: Record<string, string | number>, extra?: { path?: string; hint?: string }): never {
  const pose2d: Pose2DError = makeError(code, params, extra);
  const text = pose2d.message + (pose2d.path ? ` at ${pose2d.path}` : '') + (pose2d.hint ? `: ${pose2d.hint}` : '');
  throw Object.assign(new Error(text), { pose2d });
}
